const MONTHLY_PRICE_UPDATE = 'bfb/monthly_price/MONTHLY_PRICE_UPDATE';

export default {
  MONTHLY_PRICE_UPDATE,
};
